import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

export const MySwal = withReactContent(Swal);
